// src/api/legalApi.ts
// Adaptador de AVISO LEGAL / TÉRMINOS contra lealify-base (Inc12). Reemplaza Firebase
// (businesses/{id}/settings/legal). Se guarda en tenant_settings.legal vía /biz/settings,
// que es DE DONDE el kiosko (public.js / loyalty.js) ya lee el disclaimer — mismos nombres
// de campo → al guardar aquí, el kiosko lo recoge sin desincronizar.
import { baseApi } from './baseClient';

export interface LegalSettings {
  disclaimerEnabled: boolean;
  disclaimerPrivacyText: string;
  disclaimerRulesText: string;
  disclaimerVersion: number;
}

// /biz/settings devuelve { tenant, settings: { <skey>: <svalue> } }; svalue puede venir
// como objeto (JSON nativo) o string → se normaliza.
function parseLegal(raw: unknown): Partial<LegalSettings> {
  if (!raw) return {};
  if (typeof raw === 'string') { try { return JSON.parse(raw); } catch { return {}; } }
  return raw as Partial<LegalSettings>;
}

export const legalApi = {
  get: async (): Promise<Partial<LegalSettings> | null> => {
    const r = await baseApi.get<{ settings: Record<string, unknown> }>('/biz/settings');
    const legal = r?.settings?.legal;
    return legal ? parseLegal(legal) : null;
  },
  save: (legal: LegalSettings) =>
    baseApi.put<{ ok: true }>('/biz/settings', { settings: { legal } }),
};

export default legalApi;
